<template>
  <OrganismMap :clubs="clubs" />
</template>

<script>
import OrganismMap from '../../components/organisms/layouts/OrganismMap'

export default {
  name: 'ContactsMap',
  components: { OrganismMap },
  meta: {
    theme: 'dark',
  },
  props: {
    context: {
      default: () => {},
      required: false,
      type: Object,
    },
  },
  head() {
    return {
      title: 'Контакты клубов Encore Fitness в Москве на карте',
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: 'Контакты клубов Encore Fitness в Москве на карте',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'Контакты и адреса клубов Encore Fitness — найдите на интерактивной карте ближайший клуб в Москве, Санкт-Петербурге, Екатеринбурге или Сочи, узнайте телефоны, часы работы и как доехать.',
        },
      ],
    }
  },
  computed: {
    clubs() {
      const cityId = this.context.cityId
      return this.$store.getters['modules/content/clubs'].filter(({ city }) =>
        cityId !== 'all' ? city.id === cityId : true,
      )
    },
  },
}
</script>
